<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ng-container *ngIf="!hiddenTransactionColumns && data.canFilterByLoan">
      <ifc-account-loan-number-input [fc]="form.get('loanNumber')" baseFilterItem></ifc-account-loan-number-input>
      <ifb-business-name-input [fc]="form.get('businessName')" baseFilterItem></ifb-business-name-input>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Type</mat-label>
      <mat-select matInput multiple formControlName="type" placeholder="Type">
        <mat-option *ngFor="let option of transactionTypeOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('type').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('type').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>ID</mat-label>
      <input matInput formControlName="id" type="number" placeholder="ID" />
      <button
        type="button"
        *ngIf="form.get('id').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('id').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Amount from</mat-label>
      <input
        matInput
        formControlName="amountFrom"
        type="text"
        placeholder="Amount from"
        currencyMask
        [options]="{ precision: '2', allowNegative: true }"
      />
      <button
        type="button"
        *ngIf="form.get('amountFrom').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('amountFrom').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Amount to</mat-label>
      <input
        matInput
        formControlName="amountTo"
        type="text"
        placeholder="Amount to"
        currencyMask
        [options]="{ precision: '2', allowNegative: true }"
      />
      <button
        type="button"
        *ngIf="form.get('amountTo').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('amountTo').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Credit limit from</mat-label>
      <input
        matInput
        formControlName="creditLimitFrom"
        type="text"
        placeholder="Credit limit from"
        currencyMask
        [options]="{ precision: '2', allowNegative: true }"
      />
      <button
        type="button"
        *ngIf="form.get('creditLimitFrom').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('creditLimitFrom').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Credit limit to</mat-label>
      <input
        matInput
        formControlName="creditLimitTo"
        type="text"
        placeholder="Credit limit to"
        currencyMask
        [options]="{ precision: '2', allowNegative: true }"
      />
      <button
        type="button"
        *ngIf="form.get('creditLimitTo').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('creditLimitTo').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput multiple formControlName="status" placeholder="Status">
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('status').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('status').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Next Status</mat-label>
      <mat-select matInput formControlName="nextStatus" placeholder="Next Status">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of nextStatusOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Reject/Pending reasons</mat-label>
      <mat-select matInput multiple formControlName="failureReasons" placeholder="Reject/Pending reasons">
        <mat-option *ngFor="let option of failureReasonsOptions" [value]="option.code">{{ option.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('failureReasons').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('failureReasons').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>{{ canReadFacilities ? 'Facility' : 'No facilities permission' }}</mat-label>
      <mat-select formControlName="loanFacilityId" placeholder="All" [disabled]="!canReadFacilities">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let facility of facilities" [value]="facility.id">{{ facility.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Brand</mat-label>
      <mat-select formControlName="companyId" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>{{ readPromotions ? 'Promotions' : 'No promotions permission' }}</mat-label>
      <mat-select matInput multiple formControlName="promotionIds" placeholder="Promotions">
        <mat-option *ngFor="let option of promotionOptions" [value]="option.id">{{ option.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('promotionIds').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('promotionIds').setValue(null)"
        [disabled]="!readPromotions"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ifc-filter-param-date-range-input
      [fc]="form.get('transactionDate')"
      [label]="'Transaction Date'"
      (rangeSelected)="transactionDateSelected($event)"
      baseFilterItem
    ></ifc-filter-param-date-range-input>
    <ifc-filter-param-date-range-input
      [fc]="form.get('processDate')"
      [label]="'Processed Date'"
      (rangeSelected)="processDateSelected($event)"
      baseFilterItem
    ></ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('transactionDate').value === 'custom'">
      <ifc-datepicker [fc]="form.get('fromDate')" [label]="'Transaction date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('toDate')" [label]="'Transaction date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ng-container *ngIf="form.get('processDate').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('processDateFrom')"
        [label]="'Processed date from'"
        baseFilterItem
      ></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('processDateTo')" [label]="'Processed date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ifc-filter-param-amount-range-input
      [fc]="form.get('principalAmount')"
      [label]="'Principal amount'"
      (rangeSelected)="principalAmountSelected($event)"
      baseFilterItem
    ></ifc-filter-param-amount-range-input>
    <ifc-filter-param-amount-range-input
      [fc]="form.get('interestAmount')"
      [label]="'Interest amount'"
      (rangeSelected)="interestAmountSelected($event)"
      baseFilterItem
    ></ifc-filter-param-amount-range-input>

    <ng-container *ngIf="form.get('principalAmount').value === 'custom'">
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Principal amount from</mat-label>
        <input
          matInput
          formControlName="principalAmountFrom"
          type="text"
          placeholder="Principal amount from"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('principalAmountFrom').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('principalAmountFrom').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Principal amount to</mat-label>
        <input
          matInput
          formControlName="principalAmountTo"
          type="text"
          placeholder="Principal amount to"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('principalAmountTo').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('principalAmountTo').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="form.get('interestAmount').value === 'custom'">
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Interest amount from</mat-label>
        <input
          matInput
          formControlName="interestAmountFrom"
          type="text"
          placeholder="Interest amount from"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('interestAmountFrom').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('interestAmountFrom').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Interest amount to</mat-label>
        <input
          matInput
          formControlName="interestAmountTo"
          type="text"
          placeholder="Interest amount to"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('interestAmountTo').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('interestAmountTo').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>

    <ifc-filter-param-amount-range-input
      [fc]="form.get('deferredFeeAmount')"
      [label]="'Deferred fee amount'"
      (rangeSelected)="deferredFeeAmountSelected($event)"
      baseFilterItem
    ></ifc-filter-param-amount-range-input>
    <ifc-filter-param-amount-range-input
      [fc]="form.get('cashFeeAmount')"
      [label]="'Cash fee amount'"
      (rangeSelected)="cashFeeAmountSelected($event)"
      baseFilterItem
    ></ifc-filter-param-amount-range-input>

    <ng-container *ngIf="form.get('deferredFeeAmount').value === 'custom'">
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Deferred fee amount from</mat-label>
        <input
          matInput
          formControlName="deferredFeeAmountFrom"
          type="text"
          placeholder="Deferred fee amount from"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('deferredFeeAmountFrom').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('deferredFeeAmountFrom').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Deferred fee amount to</mat-label>
        <input
          matInput
          formControlName="deferredFeeAmountTo"
          type="text"
          placeholder="Deferred fee amount to"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('deferredFeeAmountTo').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('deferredFeeAmountTo').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="form.get('cashFeeAmount').value === 'custom'">
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Cash fee amount from</mat-label>
        <input
          matInput
          formControlName="cashFeeAmountFrom"
          type="text"
          placeholder="Cash fee amount from"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('cashFeeAmountFrom').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('cashFeeAmountFrom').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Cash fee amount to</mat-label>
        <input
          matInput
          formControlName="cashFeeAmountTo"
          type="text"
          placeholder="Cash fee amount to"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('cashFeeAmountTo').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('cashFeeAmountTo').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>

    <ifc-filter-param-amount-range-input
      [fc]="form.get('disbursedAmount')"
      [label]="'Disbursed amount'"
      (rangeSelected)="disbursedAmountSelected($event)"
      baseFilterItem
    ></ifc-filter-param-amount-range-input>

    <ng-container *ngIf="form.get('disbursedAmount').value === 'custom'">
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Disbursed amount from</mat-label>
        <input
          matInput
          formControlName="disbursedAmountFrom"
          type="text"
          placeholder="Disbursed amount from"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('disbursedAmountFrom').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('disbursedAmountFrom').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" baseFilterItem>
        <mat-label>Disbursed amount to</mat-label>
        <input
          matInput
          formControlName="disbursedAmountTo"
          type="text"
          placeholder="Disbursed amount to"
          currencyMask
          [options]="{ precision: '2', allowNegative: true }"
        />
        <button
          type="button"
          *ngIf="form.get('disbursedAmountTo').value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="form.get('disbursedAmountTo').setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>
  </ifc-base-filter-dialog>
</form>
